/**
 * 호스트 자격 저장 — 개설(landing)과 재입장("내가 연 회의실")이 **같이**
 * 쓴다(DEF-131). 두 벌로 두면 한쪽에만 필드가 늘어 재입장한 호스트 화면이
 * 개설 직후와 달라진다.
 */

import { saveCredential } from './session'

/** 개설 응답·재입장 응답에 공통인 자격 필드. */
export interface HostCredentialSource {
  room: string
  /** 구 host_key — 기본 서버 형상은 빈 문자열이거나 없다 */
  host_key?: string
  token?: string
  token_ttl_s?: number
  passcode: string
  view_key?: string
  src: string
  dst: string
  bidirectional?: boolean
  public_entry?: boolean
  name?: string
  topic?: string
}

export function saveHostCredential(src: HostCredentialSource): void {
  saveCredential({
    room: src.room,
    // 구 host_key — 기본 서버 형상(TRANS_LEGACY_ROOM_KEYS=0)은 빈
    // 문자열을 준다. 자격은 아래 토큰이다.
    key: src.host_key ?? '',
    role: 'host',
    // §5.2 host 토큰(정본 자격) — WS·방 REST 가 이걸 쓰고, 만료 전
    // lib/token.ts 가 /api/rooms/{room}/token 으로 재교환한다.
    ...(src.token
      ? {
          token: src.token,
          tokenExp: Date.now() + (src.token_ttl_s ?? 600) * 1000,
        }
      : {}),
    // 6자리 패스코드는 방 ID 와 별개 축이다(§10.0) — 호스트가 구두로
    // 공유하도록 보관하되, 어떤 URL 에도 싣지 않는다.
    passcode: src.passcode,
    // 공개 방 직통 링크(#k=)를 만들 때만 쓴다(§10.2).
    viewKey: src.view_key,
    src: src.src,
    dst: src.dst,
    // 구 서버는 undefined = 단방향. 호스트 콘솔은 방 설정 로드로 다시
    // 정본을 덮어쓴다.
    bidirectional: src.bidirectional ?? false,
    publicEntry: src.public_entry,
    name: src.name,
    topic: src.topic,
  })
}
